import { Dialog, Transition, DialogTitle, DialogBackdrop  } from '@headlessui/react';
import React, { Fragment, useRef } from 'react'

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
export default function GenericModal({ open, setOpen, onConfirm, onCancel, confirmButtonText, cancelButtonText, showCancelButton, showConfirmButton = true, title, children, className = null }) {
    const canShowConfirmButton = !!showConfirmButton
    const canShowCancelButton = !!showCancelButton
    const cancelButtonRef = useRef(null);
    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className={classNames("tailwind-preflight", className)}
                initialFocus={cancelButtonRef}
                open={open}
                onClose={setOpen}
            >
                <div className="tw-fixed tw-z-10 tw-inset-0 tw-overflow-y-auto ">
                    <div className="tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-block sm:tw-p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="tw-ease-out tw-duration-300"
                            enterFrom="tw-opacity-0"
                            enterTo="tw-opacity-100"
                            leave="tw-ease-in tw-duration-200"
                            leaveFrom="tw-opacity-100"
                            leaveTo="tw-opacity-0"
                        >
                            <DialogBackdrop className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal tw-contents. */}
                        <span className="tw-hidden sm:tw-inline-block sm:tw-align-middle sm:tw-h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="tw-ease-out tw-duration-300"
                            enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                            enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                            leave="tw-ease-in tw-duration-200"
                            leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
                            leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
                        >
                            <div className="tw-inline-block tw-align-bottom tw-bg-white tw-rounded-lg tw-px-4 tw-pt-5 tw-pb-4 tw-text-left tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 sm:tw-align-middle sm:tw-max-w-screen-sm sm:tw-w-full sm:tw-p-6">
                                <div>
                                    <div className="tw-text-center">
                                        <DialogTitle as="h3" className="tw-text-lg tw-leading-6 tw-font-medium tw-text-gray-900">
                                            {title}
                                        </DialogTitle>
                                        {children}
                                    </div>
                                </div>
                                <div className="tw-mt-4 tw-grid tw-grid-cols-6 tw-gap-4">
                                    {
                                        canShowCancelButton && (<button
                                            type="button"
                                            className="tw-col-span-3 tw-text-center tw-py-2 tw-px-4 tw-border tw-border-transparent tw-rounded-md tw-shadow-sm tw-text-sm tw-font-medium tw-text-gray-600 tw-bg-gray-300 hover:tw-bg-gray-200"
                                            onClick={() => onCancel?.call()}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    onCancel?.call();
                                                }
                                            }}
                                            ref={cancelButtonRef}
                                        >
                                            {cancelButtonText || 'Cancel'}
                                        </button>)
                                    }
                                    {
                                        canShowConfirmButton && (<button
                                            type="button"
                                            className={
                                                classNames("tw-py-2 tw-px-4 tw-border tw-border-transparent tw-rounded-md tw-shadow-sm tw-text-sm tw-font-medium tw-text-white tw-bg-indigo-700 hover:tw-bg-indigo-800",
                                                    canShowCancelButton ?
                                                        "tw-col-span-3" : "tw-col-span-4 tw-col-start-2"
                                                )
                                            }
                                            onClick={() => onConfirm?.call()}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    onConfirm?.call();
                                                }
                                            }}
                                        >
                                            {confirmButtonText || 'Confirm'}
                                        </button>
                                        )
                                    }
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
